import { forwardRef } from 'react';
import { Action, ActionProps } from '../Action';
import { HolderOutlined } from '@ant-design/icons';

export const Handle = forwardRef<HTMLButtonElement, ActionProps>(
  (props, ref) => {
    return (
      <>
        <Action
          ref={ref}
          cursor="grab"
          data-cypress="draggable-handle"
          {...props}
        >
          <HolderOutlined />
        </Action>
      </>

    );
  }
);
